import { gql } from '__generated__';

export default gql(`
  query GetEventsCount($project_id: ID!) {
    project(id: $project_id) {
      id
      events {
        total
      }
    }
  }
`);
